namespace Gamification.Gamification {
    export interface UtentiProdottiEsperienzeRow {
        UserId?: number;
        TenantId?: number;
        IdUtenteProdottoEsperienza?: number;
        IdUtenteProdotto?: number;
        IdProdottoEsperienza?: number;
        Valore?: number;
        DataOraInizio?: string;
        DataOraFine?: string;
        Stato?: number;
        IdProdottoEsperienzaNome?: string;
        IdProdottoEsperienzaPunteggioNome?: string;
        IdProdottoEsperienzaDescrizione?: string;
        IdProdottoEsperienzaIdentifierEsperienza?: string;
        IdProdottoEsperienzaPunteggioValoreNegativo?: number;
        IdProdottoEsperienzaPunteggio?: number;
    }

    export namespace UtentiProdottiEsperienzeRow {
        export const idProperty = 'IdUtenteProdottoEsperienza';
        export const localTextPrefix = 'Gamification.UtentiProdottiEsperienze';
        export const lookupKey = 'Gamification.UtentiProdottiEsperienze';

        export function getLookup(): Q.Lookup<UtentiProdottiEsperienzeRow> {
            return Q.getLookup<UtentiProdottiEsperienzeRow>('Gamification.UtentiProdottiEsperienze');
        }
        export const deletePermission = 'Gamification:Prodotti';
        export const insertPermission = 'Gamification:Prodotti';
        export const readPermission = 'Gamification:Prodotti';
        export const updatePermission = 'Gamification:Prodotti';

        export declare const enum Fields {
            UserId = "UserId",
            TenantId = "TenantId",
            IdUtenteProdottoEsperienza = "IdUtenteProdottoEsperienza",
            IdUtenteProdotto = "IdUtenteProdotto",
            IdProdottoEsperienza = "IdProdottoEsperienza",
            Valore = "Valore",
            DataOraInizio = "DataOraInizio",
            DataOraFine = "DataOraFine",
            Stato = "Stato",
            IdProdottoEsperienzaNome = "IdProdottoEsperienzaNome",
            IdProdottoEsperienzaPunteggioNome = "IdProdottoEsperienzaPunteggioNome",
            IdProdottoEsperienzaDescrizione = "IdProdottoEsperienzaDescrizione",
            IdProdottoEsperienzaIdentifierEsperienza = "IdProdottoEsperienzaIdentifierEsperienza",
            IdProdottoEsperienzaPunteggioValoreNegativo = "IdProdottoEsperienzaPunteggioValoreNegativo",
            IdProdottoEsperienzaPunteggio = "IdProdottoEsperienzaPunteggio"
        }
    }
}
